import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-quantity-plus",
  "use": "icon-quantity-plus-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"icon-quantity-plus\"><path d=\"M0 4.15V3.002h2.98V.001h1.17v3.001h2.98V4.15H4.15v2.995H2.98V4.15H0Z\" fill=\"#003C71\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol